var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "messages-people-person-bubble-oval") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,9.5h1v2l2.5-2h2a4.5,4.5,0,0,0,0-9H13A4.5,4.5,0,0,0,8.5,5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.5,23.5a8.719,8.719,0,0,1,.7-3.322c.49-.981,2.539-1.661,5.111-2.613.695-.258.581-2.074.273-2.413a5.127,5.127,0,0,1-1.336-3.978A3.354,3.354,0,0,1,8.5,7.5a3.354,3.354,0,0,1,3.256,3.674,5.127,5.127,0,0,1-1.336,3.978c-.308.339-.422,2.155.273,2.413,2.572.952,4.621,1.632,5.111,2.613a8.719,8.719,0,0,1,.7,3.322Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4.25a.75.75,0,1,0,.75.75A.75.75,0,0,0,19,4.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4.25a.75.75,0,1,0,.75.75A.75.75,0,0,0,16,4.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13,4.25a.75.75,0,1,0,.75.75A.75.75,0,0,0,13,4.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.2bf72a510d7c68111582c4441e3b6737.svg";
export { ForwardRef as ReactComponent };